import React from 'react'
import { Autocomplete, Button } from 'src/shared/components'

const ProfileContent = () => {
	return <div className="tt-max-w-5xl tt-w-full tt-mx-auto  tt-px-16 tt-py-32"></div>
}

export default ProfileContent
